import {Component, Prop, Vue} from "vue-property-decorator";
import {className} from "~/lib/helpers/string";

@Component
export class Confirm extends Vue {

  @Prop({type: Boolean, default:false}) isActive: boolean;
  @Prop({type: String, default:"std"}) type: "std" | "danger";

  render(){
    return (
      <div class={className("modal", {isActive: this.isActive})}>
        <div class="modal-background" />
        <div class="modal-content">
          <div class="box">
            {this.$slots.default}
            <div class="actions m-t-20">
              <button class="button is-small" onClick={() => this.$emit("close")}>Annuler</button>
              <button class={`button is-small ${this.type === "std" ? "is-primary" : "is-danger"}`} onClick={() => this.$emit("confirm")}>Je confirme</button>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-42efd7c3/confirm.tsx" });